import { createSelector, createSlice } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { stringToColor } from '@sceneio/tools/lib/stringToColor'
import { LoginByNameThunkArguments, UserSliceType } from './userSliceTypes'
import { AppDispatch, RootState } from '../../store'
import { createGraphqlAsyncThunk } from '../../helpers/createGraphqlAsyncThunk'
import { asyncThunkFetcher } from '../../helpers/asyncThunkFetcher'
import { randomString } from '@sceneio/tools'
import { fetchContent } from '../content/contentSlice'

export * from './userSliceSelectors'

function generateToken() {
  const rand = () => Math.random().toString(36).substring(2, 15)
  return rand() + rand() + '-' + rand() + rand()
}

// ---------------
// Initial State
// ---------------
export const initialState: UserSliceType = {
  id: '',
  name: '',
  token: null,
  localPreferences: {},
  // email: '',
  // isLoggedIn: false,
  // selectedCmsLanguage: 'en',
  // selectedProject: null,
  // originUser: null,
  // createdAt: '',
} as UserSliceType // https://github.com/reduxjs/redux-toolkit/pull/827

// ---------------
// Thunks
// ---------------
export const loginByName = createGraphqlAsyncThunk<
  UserSliceType,
  LoginByNameThunkArguments
>('user/login', async (variables, thunkAPI) => {
  return new Promise((resolve) => {
    resolve({
      id: randomString(),
      name: variables.name,
      token: generateToken(),
    })
  })
  // TODO connect to login mutation
  // return await asyncThunkFetcher({
  //   query: 'LoginByNameMutationDocument',
  //   selector: 'loginByName',
  //   variables,
  //   thunkAPI,
  // })
})

// ---------------
// Reducer
// ---------------

export const userSlice = createSlice({
  name: 'user',
  initialState: () => initialState,
  reducers: {
    login: (state, action: { payload: UserSliceType }) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    logout: (state) => {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginByName.fulfilled, (state, action) => {
        state.id = action.payload.id
        state.name = action.payload.name
        state.token = action.payload.token
      })
      .addCase('USER:LOGOUT', () => {
        return initialState
      })
  },
})

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useUserDispatch: () => AppDispatch = useDispatch
export const useUserSelector: TypedUseSelectorHook<RootState> = useSelector

// Action creators are generated for each case reducer function
export const { login, logout } = userSlice.actions

export default userSlice.reducer
